export default "__VITE_ASSET__DRrLCTsw__"